import $ from "jquery"

$(require("../components/main_layout/client.coffee"))
